import axios from "axios";

const api = axios.create({
  baseURL: "https://app.kedemailer.com/api", //PROD 146.190.35.243 // nginx will rerout to 3000
  //baseURL: "http://localhost:3000/api", //Local
});

// Add Authorization header to every request if token is available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const fetchQuestion = (questionId) => api.get(`/questions/${questionId}`);
export const saveResponse = (responseData) => api.post(`/responses`, responseData);

export default api;
